import { useTranslation } from "react-i18next";

import { AddIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "../../../../../DesignComponents/Button";
import { FirstButtonProps, STEPS } from "../types";

const FirstButton = ({
    isInitialStep,
    setSelectedConfiguration,
    handleStep,
    handleSubmitCreate
}: FirstButtonProps) => {
    const { t } = useTranslation();

    return isInitialStep ? (
        <Button
            fullWidth
            color={BUTTON_COLORS.PrimarySubtle}
            size={BUTTON_SIZES.Normal}
            variant={BUTTON_VARIANTS.IconLeft}
            icon={<AddIcon />}
            onClick={handleSubmitCreate}
        >
            {t("Button##create")}
        </Button>
    ) : (
        <Button
            fullWidth
            color={BUTTON_COLORS.Secondary}
            size={BUTTON_SIZES.Normal}
            variant={BUTTON_VARIANTS.TextOnly}
            onClick={() => {
                handleStep(STEPS.Initial);
                setSelectedConfiguration(null);
            }}
        >
            {t("Button##back")}
        </Button>
    );
};

export default FirstButton;
